export default __webpack_public_path__ + "static/media/request-progress.5f64f74f.svg";